import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

function Spinner(props) {
  return (
    <div
      className={classnames(styles.spinner, {
        [styles[props.size]]: true,
        [styles.delayed]: props.delayed
      })}
    />
  );
}

Spinner.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  delayed: PropTypes.bool
};

Spinner.defaultProps = {
  size: 'medium',
  delayed: false
};

export default memo(Spinner);
